// extracted by mini-css-extract-plugin
export default {"wrapper":"ffa","container":"gfa","image":"hfa","info":"ifa","title":"jfa","note":"kfa","product":"lfa","product_img":"mfa","description":"nfa","name":"ofa","whybtn":"pfa","buttons":"qfa"};
    if(module.hot) {
      // 1737143665396
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  